import React, { Suspense } from 'react';

import { PreCheckoutProvider } from './PreCheckoutContext';
import { CheckoutLoading } from '../components/templates';

export * from './PreCheckoutContext';

export const CheckoutLocalContainer: React.FC = ({ children }) => (
  <Suspense fallback={<CheckoutLoading />}>
    <PreCheckoutProvider>{children}</PreCheckoutProvider>
  </Suspense>
);
